const theme = {
    palette: {
        primary: {
            main: '#915122',
        },
    },
}

export default theme